const ServiceIconConfig = {
  small: {
    width: "var(--zds-size-small)",
    borderRadius: "var(--zds-radius-small)",
    iconSize: 14
  },
  medium: {
    width: "var(--zds-size-medium)",
    borderRadius: "var(--zds-radius-medium)",
    iconSize: 24
  },
  large: {
    width: "var(--zds-size-large)",
    borderRadius: "var(--zds-radius-medium)",
    iconSize: 32
  },
  20: {
    borderRadius: "3px",
    iconSize: 14,
    width: "20px"
  },
  30: {
    borderRadius: "3px",
    iconSize: 20,
    width: "30px"
  },
  40: {
    borderRadius: "5px",
    iconSize: 30,
    width: "40px"
  },
  60: {
    borderRadius: "8px",
    iconSize: 40,
    width: "60px"
  },
  80: {
    borderRadius: "10px",
    iconSize: 60,
    width: "80px"
  },
  120: {
    borderRadius: "15px",
    iconSize: 90,
    width: "120px"
  },
  150: {
    borderRadius: "18px",
    iconSize: 110,
    width: "150px"
  }
};

export { ServiceIconConfig };
//# sourceMappingURL=constants.es.js.map
